"use client";

import HeroSection from "@/components/page-section/HeroSection/HeroSection";
import { getImageUrl } from "@/utils/api-utils";
import {
  overlayDefaultsFromCmsFields,
  slideItemsFromCmsRows,
  type CmsHeroSlideRow,
} from "@/utils/cms-hero-slides";
import { normalizeCmsAssetUrl } from "@/utils/media-url";

export type LichSuHeroCmsContent = {
  type?: string;
  image?: string;
  alt?: string | null;
  slides?: CmsHeroSlideRow[];
  brand?: string;
  title?: string;
  button?: {
    label?: string;
    href?: string;
    variant?: string;
    openInNewTab?: boolean;
    target?: string;
  };
};

type LichSuHeroProps = {
  currentLabel?: string;
  hero?: LichSuHeroCmsContent | null;
};

const FALLBACK = {
  brand: "HUB",
  title: "LỊCH SỬ HÌNH THÀNH",
  label: "Xem chi tiết",
  href: "#about",
};

export default function LichSuHero({
  currentLabel = "Lịch sử hình thành",
  hero,
}: LichSuHeroProps) {
  const heroSlides = (() => {
    const fromSlides = slideItemsFromCmsRows(hero?.slides ?? null);
    if (fromSlides) return fromSlides;
    if (typeof hero?.image === "string" && hero.image.trim()) {
      const raw = getImageUrl(hero.image) || hero.image;
      const img = normalizeCmsAssetUrl(raw) || raw;
      return [{ image: img, alt: hero.alt ?? "Banner" }];
    }
    return null;
  })();

  const hasNewCmsShape = !!hero?.slides?.length;

  const overlayDefaults = hasNewCmsShape
    ? overlayDefaultsFromCmsFields(hero?.brand, hero?.title, hero?.button, FALLBACK)
    : null;

  return (
    <HeroSection
      pageKey="lich-su"
      variant="carousel"
      sectionModifier="hero-section--banner hero-section--lichsu"
      ariaLabel="Banner lịch sử"
      overrideSlides={heroSlides}
      overlayDefaults={overlayDefaults}
      breadcrumb={[
        { label: "Trang chủ", href: "/" },
        { label: currentLabel },
      ]}
    />
  );
}
